import type * as React from 'react'

import { cn } from '@nwwp/ui-shadcn/lib/utils'

type MarketingPageLayoutProps = React.ComponentProps<'div'>

/** Max-width page shell. Page owns the single `<main>` — this is not a landmark. */
function MarketingPageLayout({ className, ...props }: MarketingPageLayoutProps) {
  return (
    <div
      data-slot="marketing-page-layout"
      className={cn('mx-auto flex w-full max-w-3xl flex-col gap-12 px-4 py-8', className)}
      {...props}
    />
  )
}

type MarketingSectionProps = React.ComponentProps<'section'> & {
  title?: string
}

/** Titled prose/section wrapper using design tokens. */
function MarketingSection({ className, title, children, ...props }: MarketingSectionProps) {
  return (
    <section
      data-slot="marketing-section"
      className={cn('flex flex-col gap-4 text-body text-foreground', className)}
      {...props}
    >
      {title ? <h2 className="text-title-xl text-foreground">{title}</h2> : null}
      {children}
    </section>
  )
}

export { MarketingPageLayout, MarketingSection }
export type { MarketingPageLayoutProps, MarketingSectionProps }
